export var getAssigneeName = function (ticket) {
    if (ticket.assignee) {
        return ticket.assignee.first_name + " " + ticket.assignee.last_name;
    }
    return 'Sin Asignar';
};
export var getClientType = function (ticket) {
    if (ticket.internal) {
        return 'Interno';
    }
    if (ticket.external_client) {
        return 'Externo';
    }
    return 'Cliente';
};
